(function() {
  function onDocumentReady() {
    const formElement = document.querySelector('form.cmp-form');
    const uploadElement = formElement.querySelector('.cmp-form-text .cmp-form--file');

    uploadElement.addEventListener('change', function(e) {
      e.preventDefault();
      if (uploadElement.files.length > 0) {
        for (let i = 0; i <= uploadElement.files.length - 1; i++) {
          const fileSize = uploadElement.files[i].size;
          const maxFileSize = 7340032; // Max File Size = 7MB
          if (fileSize > maxFileSize) {
            uploadElement.value = "";
            uploadElement.classList.add('cmp-form-text--invalid', 'constraint-class');
          } else {
            uploadElement.classList.remove('cmp-form-text--invalid', 'constraint-class');
          }
        }
      }
    });
  }

  if (document.readyState !== "loading") {
    onDocumentReady();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentReady);
  }
})();